import React, { Component } from "react";
import { debounce } from "lodash";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Creators as BenefitsActions,
  Selectors as BenefitsSelectors,
} from "store/ducks/benefits";
import {
  Creators as CommercialCampaignsActions,
  Selectors as CommercialCampaignsSelectors,
} from "store/ducks/commercialCampaign";

import { Access } from "common";
import { Form } from "components";

class Filters extends Component {
  state = {
    filter: this.props.filter,
    status: [
      { value: "", label: "Todos" },
      { value: "approve", label: "Aprovado" },
      { value: "reproved", label: "Reprovado" },
      { value: "pending", label: "Pendente" },
      { value: "processing", label: "Processando" },
      { value: "expired", label: "Expirado" },
      { value: "failed", label: "Falho" },
    ],
    sellers: [{ value: "", label: "Todos" }],
    app_only: [
      { value: "", label: "Todos" },
      { value: true, label: "Sim" },
      { value: false, label: "Não" },
    ],
  };

  constructor(props) {
    super(props);

    const {
      getBenefitStoresRequest,
      getBenefitCategoriesRequest,
      getComercialCampaignsRequest,
      getBenefitChannelsRequest,
    } = props;

    this.handleSearchStores = debounce(getBenefitStoresRequest, 300);
    this.handleSearchTypes = debounce(getBenefitCategoriesRequest, 300);
    this.handleSearchCampaigns = debounce(getComercialCampaignsRequest, 300);
    this.handleSearchChannels = debounce(getBenefitChannelsRequest, 300);
  }

  componentDidMount() {
    const {
      getBenefitStoresRequest,
      getBenefitCategoriesRequest,
      getBenefitChannelsRequest,
      getComercialCampaignsRequest,
    } = this.props;

    getBenefitStoresRequest();
    getBenefitCategoriesRequest();
    getBenefitChannelsRequest();
    getComercialCampaignsRequest(1, 9000, true);
  }

  componentDidUpdate(oldProps) {
    const { filter } = this.props;

    if (oldProps.filter !== filter) {
      this.setState({ filter });
    }
  }

  handleFindTypes = (query) => {
    this.handleSearchTypes(query);
  };

  handleFindChannels = (query) => {
    this.handleSearchChannels(query);
  };

  handleFindCampaigns = (query) => {
    this.handleSearchCampaigns(1, 9000, true);
  };

  render() {
    const { filter, status, app_only } = this.state;
    const { stores, types, channels, commercialCampaigns, onChange, onClean } =
      this.props;

    return (
      <Form className="row">
        <Form.Field className="col-md-3">
          <Form.Label>Lojas</Form.Label>
          <Form.Select
            placeholder="Lojas"
            value={filter.store}
            options={stores.data}
            onChange={(value) => onChange("store", value)}
            noOptionsMessage={() => "Loja não encontrada"}
            cleaneable
            isDisabled={!!Access.lockedStore()}
          />
        </Form.Field>

        <Form.Field className="col-md-3">
          <Form.Label>Período, de</Form.Label>
          <Form.Icon name="calendar">
            <Form.DatePicker
              dateFormat="dd/MM/yyyy"
              selected={filter.start_at}
              onChange={(value) => onChange("start_at", value)}
            />
          </Form.Icon>
        </Form.Field>

        <Form.Field className="col-md-3">
          <Form.Label>Período, até</Form.Label>
          <Form.Icon name="calendar">
            <Form.DatePicker
              dateFormat="dd/MM/yyyy"
              selected={filter.end_at}
              onChange={(value) => onChange("end_at", value)}
              minDate={filter.start_at}
              disabled={filter.start_at === null}
            />
          </Form.Icon>
        </Form.Field>

        <Form.Field className="col-md-3">
          <Form.Label>Tipo</Form.Label>
          <Form.Select
            placeholder="Tipo"
            value={filter.type}
            options={types.data}
            onChange={(value) => onChange("type", value)}
            onInputChange={this.handleFindTypes}
            noOptionsMessage={() => "Tipo não encontrado"}
          />
        </Form.Field>

        <Form.Field className="col-md-3">
          <Form.Label>Canal</Form.Label>
          <Form.Select
            placeholder="Tipo"
            value={filter.channel}
            options={channels.data}
            onChange={(value) => onChange("channel", value)}
            onInputChange={this.handleFindChannels}
            noOptionsMessage={() => "Canal não encontrado"}
          />
        </Form.Field>

        <Form.Field className="col-md-3">
          <Form.Label>Situação</Form.Label>
          <Form.Select
            placeholder="Situação"
            value={filter.status}
            options={status}
            onChange={(value) => onChange("status", value)}
          />
        </Form.Field>

        <Form.Field className="col-md-3">
          <Form.Label>Campanha APP</Form.Label>
          <Form.Select
            placeholder="Campanha APP"
            value={filter.app_only}
            options={app_only}
            onChange={(value) => onChange("app_only", value)}
          />
        </Form.Field>

        <Form.Field className="col-md-3">
          <Form.Label>Campanha Comercial</Form.Label>
          <Form.Select
            placeholder="Campanha comercial"
            value={filter.commercialCampaign}
            options={[
              { value: "", label: "Todos" },
              ...commercialCampaigns.data,
            ]}
            noOptionsMessage={() => "Nenhuma campanha encontrada"}
            onChange={(value) => onChange("commercialCampaign", value)}
          />
        </Form.Field>

        <Form.Field className="col-md-9">
          <Form.Label>Descrição do Benefício</Form.Label>
          <Form.Input
            value={filter.description}
            onChange={({ target }) => onChange("description", target.value)}
          />
        </Form.Field>

        <Form.Field className="col-md-3">
          <Form.Button className="button-clean-filter" onClick={onClean}>
            Resetar Filtro
          </Form.Button>
        </Form.Field>
      </Form>
    );
  }
}

const mapState = (state) => ({
  stores: {
    ...state.benefits.stores,
    data: BenefitsSelectors.stores(state.benefits.stores.data),
  },

  types: {
    ...state.benefits.categories,
    data: BenefitsSelectors.categories(state.benefits.categories.data),
  },

  channels: {
    ...state.benefits.channels,
    data: BenefitsSelectors.channels(state.benefits.channels.data),
  },

  commercialCampaigns: {
    ...state.commercialCampaign,
    data: CommercialCampaignsSelectors.list(state.commercialCampaign.data),
  },
});

const mapActions = (dispatch) =>
  bindActionCreators(
    { ...BenefitsActions, ...CommercialCampaignsActions },
    dispatch
  );

export default connect(mapState, mapActions)(Filters);
